var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonArrowNextExtended(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.15 6.64c.182 0 .342.053.471.14.39.319.45.894.135 1.288-.065.076-.065.076-.14.141l-5.564 4.488-1.062-1.328 5.63-4.54.53 1.515H.848A.85.85 0 010 7.492c0-.47.38-.851.848-.851h10.893L7.99 3.615a.854.854 0 01-.13-1.197.846.846 0 011.192-.13l5.564 4.487c.446.3.548.992.065 1.381l-5.63 4.54c-.88.712-1.943-.616-1.061-1.327l5.563-4.487c-.064.055-.064.055-.12.12a.785.785 0 00.12 1.1l-1.812-1.461h2.41z",
    fill: "currentColor"
  })));
}

export default SvgCommonArrowNextExtended;